import styled, { createGlobalStyle } from 'styled-components';

import bold from '../../assets/font/JetBrainsMono-Bold.ttf';
import italic from '../../assets/font/JetBrainsMono-SemiBold.ttf';
import regular from '../../assets/font/JetBrainsMono-Regular.ttf';
import inter from '../../assets/font/Inter-Regular.ttf';

export const AppHolder = styled.div`
  @font-face {
    font-family: 'JetBrains Mono Regular';
    src: url(${regular});
    font-weight: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'JetBrains Mono Italic';
    src: url(${italic});
    font-weight: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'JetBrains Mono Bold';
    src: url(${bold});
    font-weight: normal;
    font-display: fallback;
  }
  @font-face {
    font-family: 'Inter';
    src: url(${inter});
    font-weight: normal;
    font-display: fallback;
  }

  font-family: 'JetBrains Mono Regular';
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
`;

export const ThemedGlobalStyle = createGlobalStyle`
html {
  width:100vw;
  height:100vh;
  scroll-behavior: smooth;
  
}
  body {
   width:100%;
   height:100%;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  a,
  p,
  li,
  input,
  textarea,
  span,
  div,
  img,
  th,
  td,
  svg {
    margin: 0;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body, html {
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
 
  #root {
    display: flex;
    flex-direction: column;
    width: 100vw;
    overflow-x: hidden;
  }
`;
